import React from "react"
import PopularCities from '../components/popular-cities'
import BlogPosts from '../components/blog-posts'
import ConnectDumpsters from "../components/connect-dumpsters"
import BlockHowToGuidesDumpsters from "../components/how-to-guides-dumpsters"
import ServicesDumpsters from "../components/services-dumpsters"
import ZipFinderSmall from "../components/zip-finder-small"
import LayoutDumpster from "../components/layout-dumpster"

const BLOGPAGEDUMPSTER = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;       
    const ziptitle = 'Find the Right Pro. Simply.';

    const cities = pageContext.cities.length > 0 ? pageContext.cities : [];
    const paginationInfo = pageContext.pagination;

    const seo = 
    {
        url: 'blog',
        env: env,
        code: code,
        page: pageContext.tags ? 'tags' : 'blogs'
    }

    const getTitle = () =>
    {
        let title = 'Waste Removal Tips & Advice';

        if(pageContext.tag != undefined)
        {
            if(pageContext.tag.name != undefined) title = pageContext.tag.name
        }

        return title
    }

    return (
        <LayoutDumpster seo={seo} env={env} code={code} bgcolor={'#f5f5f5'} >
            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{getTitle()}</h1>
                            <BlogPosts posts={posts} paginationInfo={paginationInfo} site={env.site}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">

                                <div className="block">                                    
                                    <ZipFinderSmall
                                        type = {'small'} 
                                        id = {'block-zip-finder'} 
                                        env = {env} 
                                        code = {code}
                                        placeholder = 'Enter Zip Code'
                                        title = {ziptitle}
                                        finderopenmodal={false}
                                        button= 'Get Started'
                                        />
                                </div>

                                <div className="block">
                                    <ServicesDumpsters env={env} />
                                </div>

                                <div className="block">
                                    <BlockHowToGuidesDumpsters />
                                </div>

                                <div className="block">
                                    <PopularCities env={env} cities={cities} />
                                </div>
                    

                                <div className="block">
                                    <ConnectDumpsters />
                                </div>

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDumpster>
    )
};

export default BLOGPAGEDUMPSTER;